// Who must use 2-step login (Deepti, 2 Nov 2026): the super admin and clinic admins. Doctors and reception may
// turn it on but don't have to. Step 1 (now): the app sends these roles to the set-up page until it's on.
// Step 2 (after the super admin has set hers up): firestore.rules and the server also refuse them without it.
import type { Role } from '../types';

// Paused (Deepti, 2 Nov 2026): the authenticator app was too hard. Back on once the email-code version is built.
export const TWO_STEP_REQUIRED: Role[] = [];
export const twoStepRequired = (role: Role) => TWO_STEP_REQUIRED.includes(role);
